<script lang="ts">
    import { lg, cfg } from './consent'
    import type { Technology } from './types'
    import { closeIcon } from './icons'
    import Icon from './Icon.svelte'

    interface Props {
        item: Technology
        close: () => void
    }

    let { item, close }: Props = $props()
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape') {
            close()
        }
    }}
/>
<div id="conb-info" aria-modal="true">
    <div class="conb-info-box">
        <div class="conb-info-title" role="heading" aria-level="1">
            <div class="conb-text">{item.name[$lg.id]}</div>
            <div class="conb-close">
                <button
                    type="button"
                    class="conb-iconb"
                    aria-label={$cfg['close-text'][$lg.id]}
                    onclick={() => {
                        close()
                    }}><Icon icon={closeIcon} /></button
                >
            </div>
        </div>
        {#if item.info_html.desc}
            <div class="conb-info-label" role="heading" aria-level="2">{$cfg['info-label-desc'][$lg.id]}</div>
            <div class="conb-info-value">{@html item.info_html.desc[$lg.id]}</div>
        {/if}
        {#if item.info_html.collected}
            <div class="conb-info-label" role="heading" aria-level="2">{$cfg['info-label-collected'][$lg.id]}</div>
            <div class="conb-info-value">{@html item.info_html.collected[$lg.id]}</div>
        {/if}
        {#if item.info_html.cookies}
            <div class="conb-info-label" role="heading" aria-level="2">{$cfg['info-label-cookies'][$lg.id]}</div>
            <div class="conb-info-value">{@html item.info_html.cookies[$lg.id]}</div>
        {/if}
        {#if item.extra_info != null && item.extra_info.length}
            {#each item.extra_info as einfo}
                <div class="conb-info-label" role="heading" aria-level="2">{einfo.title[$lg.id]}</div>
                <div class="conb-info-value">{@html einfo.html[$lg.id]}</div>
            {/each}
        {/if}
        {#if item.privacy_url != null}
            <div class="conb-info-label" role="heading" aria-level="2">{$cfg['info-label-privacyurl'][$lg.id]}</div>
            <div class="conb-info-value"><a href={item.privacy_url} target="_blank">{item.privacy_url}</a></div>
        {/if}
    </div>

    <div
        aria-hidden="true"
        class="conb-info-backdrop"
        onclick={() => {
            close()
        }}
    ></div>
</div>
